module.exports = __webpack_public_path__ + "static/media/teacher1.c9f4e555.svg";